export default {
  EmailModel: () => import('./EmailModel'),
};
